import { render, staticRenderFns } from "./articleField.vue?vue&type=template&id=6843f71e&scoped=true&"
import script from "./articleField.vue?vue&type=script&lang=js&"
export * from "./articleField.vue?vue&type=script&lang=js&"
import style0 from "./articleField.vue?vue&type=style&index=0&id=6843f71e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6843f71e",
  null
  
)

export default component.exports